var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRealTimeClarity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m195 30c-28.278 0-88.527 0-105 0l-15 15 15 15h75v45.897l14.871 16.769 15.129-25.672c0-18.142 0-56.288 0-66.994z",
    fill: "#d8e3fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345 404.103-14.871-16.603-15.129 25.506v66.994h105l23-15-23-15c-20.194 0-63.236 0-75 0 0-36.078 0-9.821 0-45.897z",
    fill: "#b3c9f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315 96.994 15.129 23.006 14.871-14.103c0-36.078 0-9.821 0-45.897h75l17-15-17-15c-28.278 0-88.527 0-105 0z",
    fill: "#b3c9f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165 450c-20.194 0-63.236 0-75 0l-21 15 21 15h105c0-18.143 0-56.289 0-66.994-5.072-1.19-10.117-27.018-15.129-28.506-4.991-1.482-9.95 21.377-14.871 19.603z",
    fill: "#d8e3fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.732 247.989c-.055.104-3.849 7.28-3.707 7.011.055.104 3.849 7.28 3.707 7.011 49.884 94.36 146.624 157.989 251.268 157.989l17-165-17-165c-105.854 0-201.999 64.791-251.268 157.989z",
    fill: "#4f4f86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.268 262.011c.055-.104 3.848-7.28 3.706-7.011-.055-.104-3.848-7.28-3.706-7.011-48.988-92.665-144.869-157.989-251.268-157.989v330c106.691 0 202.428-65.604 251.268-157.989z",
    fill: "#3f3f72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.092 255c46.137 81.456 131.607 135 220.908 135l19.5-135-19.5-135c-89.412 0-174.83 53.648-220.908 135z",
    fill: "#eaf0fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m475.908 255c-46.137-81.456-131.607-135-220.908-135v270c89.413 0 174.831-53.649 220.908-135z",
    fill: "#d8e3fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 255c0 74.556 60.439 135 135 135l19.5-135-19.5-135c-74.557 0-135 60.44-135 135z",
    fill: "#73e8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390 255c0-74.557-60.439-135-135-135v270c74.556 0 135-60.44 135-135z",
    fill: "#40beff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180 255c0 41.42 33.577 75 75 75l17-75-17-75c-41.42 0-75 33.577-75 75z",
    fill: "#ffd737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 255c0-41.42-33.577-75-75-75v150c41.42 0 75-33.577 75-75z",
    fill: "#ffb048"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.062,
    cy: 223.938,
    fill: "#ff9059",
    r: 31.062
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 90h90c0-10.889 0-79.039 0-90-10.889 0-79.039 0-90 0z",
    fill: "#73e8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420 510h90c0-10.889 0-79.039 0-90-10.889 0-79.039 0-90 0z",
    fill: "#ff5959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510 90c0-10.889 0-79.039 0-90-10.889 0-79.039 0-90 0v90z",
    fill: "#50c778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 510h90c0-10.889 0-79.039 0-90-10.889 0-79.039 0-90 0z",
    fill: "#ffd737"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTimeClarity);
export default __webpack_public_path__ + "static/media/real-time-clarity.a0f4c39e7f46784bac5ff295a2b853f3.svg";
export { ForwardRef as ReactComponent };